import Promise from 'promise';
import {toastr} from 'react-redux-toastr';

import { axios, SVCMessage } from '../_helpers';

export const VideoDetailService = {
    addToFavorite,
    getFavoriteByUser,
    deleteFavoriteVideo,
    deleteVideoFromTopic,
    deleteVideoFromSubTopic,
    getUnallocatedVideos
};

function addToFavorite(data) {
    return new Promise(function (resolve, reject) {
        axios.post('saveVideoAsFavorite', data).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
                 toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function deleteFavoriteVideo(data) {
     return new Promise(function (resolve, reject) {
        axios.post('deleteFavoriteVideo', data).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
              //  toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => { 
            reject(error.message);
        });
    });
 };

function getFavoriteByUser(user) {
    return axios.post('getFavoriteVideos',user).then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function deleteVideoFromTopic(topicId, userId, videoId) {
    return new Promise(function (resolve, reject) {
        axios.get("deleteVideoFromTopic?topicId=" + topicId + "&userId="+ userId + "&videoId=" + videoId).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function deleteVideoFromSubTopic(subTopicId, userId, videoId) {
    return new Promise(function (resolve, reject) {
        axios.get("deleteVideoFromSubTopic?subTopicId=" + subTopicId + "&userId="+ userId + "&videoId=" + videoId).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};


function getUnallocatedVideos() {
    return  axios.get('unallocatedVideos').then( (res) => {
        return res.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};


// WEBPACK FOOTER //
// ./src/_services/video-detail.service.js